import type { FC } from 'react';

import { useAudioTrigger } from '../../../controllers/audioController';
import { Icon, Icons } from '../../icons';
import { L12nText } from '../../text';
import { useHistoryNavigation } from '../hooks/useHistoryNavigation';

import styles from './HistoryFooter.module.css';

interface NavigationButtonProps {
  onClick: () => void;
  disabled?: boolean;
  tk?: string;
  iconDirection?: 'left' | 'right';
  noNextRecord?: boolean;
}
export const NavigationButton: FC<NavigationButtonProps> = ({
  onClick,
  disabled,
  tk,
  iconDirection = 'left',
  noNextRecord = false,
}): React.ReactNode => {
  const audioTrigger = useAudioTrigger();
  const handleClick = (): void => {
    audioTrigger.play({ name: 'menuClick' });
    onClick();
  };
  return (
    <button
      className={`${styles.button} ${noNextRecord ? styles.noNextRecord : ''}`}
      onClick={handleClick}
      disabled={disabled}
      type="button"
    >
      {iconDirection === 'left' ? <Icon icon={Icons.ChevronLeft} /> : null}
      {tk ? <L12nText tk={tk} /> : null}
      {iconDirection === 'right' ? <Icon icon={Icons.ChevronRight} /> : null}
    </button>
  );
};

export const HistoryFooter = (): React.ReactNode => {
  const { handleNext, handlePrev, isLastGame, isFirstGame, isLoadingDetails } = useHistoryNavigation();
  return (
    <div className={styles.footerContainer}>
      <NavigationButton
        onClick={handlePrev}
        disabled={isFirstGame || isLoadingDetails}
        noNextRecord={isFirstGame}
        tk="PREVIOUS"
        iconDirection="left"
      />
      <NavigationButton
        onClick={handleNext}
        disabled={isLastGame || isLoadingDetails}
        noNextRecord={isLastGame}
        tk="NEXT"
        iconDirection="right"
      />
    </div>
  );
};
